import { Col, Row, Card, Modal } from "antd";
import "./style.css";
import { useCallback, useEffect, useState } from "react";
import { getApis } from "../../Common/apis";
import { allVehicleDetailListApiUrl } from "../../Common/endpoints";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess";
import { ORG_TYPES, ROLES } from "../../Common/Constants";
import VehicleTable from "./VehicleTable";
import VehicleModal from "./VehicleModal";

const VehicleInformation = () => {
  const authToken = localStorage.getItem("authToken");
  const checkAccess = useRequiredAccess(
    [ROLES.ERPUSER],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  const [vehicleTableData, setVehicleTableData] = useState({
    List: [],
    totalElements: 0,
  });
  const [paginationDetails, setPaginationDetails] = useState({
    current: 1,
    pageSize: 10,
    field: "imei",
    order: "ascend",
  });
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const getVehicleList = useCallback(async () => {
    await getApis(
      allVehicleDetailListApiUrl,
      {
        page: paginationDetails.current - 1,
        size: paginationDetails.pageSize,
        sort:
          paginationDetails.order === "ascend"
            ? paginationDetails.field + ",asc"
            : paginationDetails.field + ",desc",
        imei: paginationDetails?.imei?.[0],
        modelName: paginationDetails?.modelName?.[0],
        chassisNumber: paginationDetails?.chassisNumber?.[0],
        operationStatus: paginationDetails?.operationStatus?.[0],
      },
      authToken
    )
      .then((res) => {
        setVehicleTableData({
          List: res?.data?.vehicleDetailDto,
          totalElements: res?.data?.totalElements,
        });
      })
      .catch((e) => console.log(e));
  }, [authToken, paginationDetails]);

  useEffect(() => {
    checkAccess();
    getVehicleList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getVehicleList]);

  const updatePaginationDetails = (value) => {
    setPaginationDetails(value);
  };

  const onSelectVehicle = (data) => {
    setSelectedVehicle(data);
    showModal();
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setSelectedVehicle({});
    setIsModalOpen(false);
  };

  return (
    <div className="vehicle-info-page" data-testid="vehicle-information">
      {isModalOpen && <Modal
        title="Vehicle Details"
        centered
        open={isModalOpen}
        onCancel={handleCancel}
        className="compare-modal vehicle-info-modal"
        footer={null}
        width="100%"
        style={{ top: 0 }}
      >
        <Card className="pd1">
          <VehicleModal selectedVehicle={selectedVehicle} />
        </Card>
      </Modal>
      }
      <Row gutter={[16, 16]} className="">
        <Col span={24}>
          <div className="card p0">
            <VehicleTable
              tableData={vehicleTableData}
              onSelectVehicle={onSelectVehicle}
              paginationDetails={paginationDetails}
              updatePaginationDetails={updatePaginationDetails}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default VehicleInformation;
